import { MessageCircle, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

export default function ContactBand() {
  const { lang } = useLanguage();
  const isEs = lang === "es";

  return (
    <section
      id="contact"
      className="border-t border-[#E5DACC] bg-[#FAF7F2] py-16 md:py-24"
      data-testid="contact-band"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid items-center gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.32em] text-[#FF5533]">
              {isEs ? "Contáctanos" : "Get in touch"}
            </p>
            <h2
              className="text-4xl leading-[1.02] tracking-tight md:text-5xl"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              {isEs ? "Escríbenos o llámanos." : "Message or call us."}
            </h2>
            <p className="mt-5 max-w-md text-base text-[#4A4A4A] md:text-[17px]">
              {isEs
                ? "Para reservas, preguntas o tours privados — te respondemos en menos de 24 horas."
                : "For bookings, questions or private tours — we reply within 24 hours."}
            </p>
          </div>
          <div className="grid gap-4 md:col-span-7 md:grid-cols-2">
            <Link
              to="/contact"
              data-testid="home-contact-form"
              className="group flex items-center gap-4 rounded-2xl border border-[#E5DACC] bg-white p-5 transition-all hover:-translate-y-0.5 hover:border-[#FF5533]/40 hover:shadow-lg md:p-6"
            >
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#FF5533]/10 text-[#FF5533] transition-colors group-hover:bg-[#FF5533] group-hover:text-white">
                <MessageCircle size={20} strokeWidth={1.75} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#FF5533]">
                  {isEs ? "Formulario" : "Message form"}
                </div>
                <div
                  className="mt-1 text-base font-semibold text-[#0A0A0A] md:text-lg"
                  style={{ fontFamily: "Manrope, sans-serif" }}
                >
                  {isEs ? "Envíanos un mensaje" : "Send us a message"}
                </div>
              </div>
            </Link>
            <a
              href="tel:+17878276237"
              data-testid="home-contact-phone"
              className="group flex items-center gap-4 rounded-2xl border border-[#E5DACC] bg-white p-5 transition-all hover:-translate-y-0.5 hover:border-[#FF5533]/40 hover:shadow-lg md:p-6"
            >
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#FF5533]/10 text-[#FF5533] transition-colors group-hover:bg-[#FF5533] group-hover:text-white">
                <Phone size={20} strokeWidth={1.75} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#FF5533]">
                  {isEs ? "Teléfono" : "Phone"}
                </div>
                <div
                  className="mt-1 text-base font-semibold text-[#0A0A0A] md:text-lg"
                  style={{ fontFamily: "Manrope, sans-serif" }}
                >
                  +1 (787) 827-6237
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
